<template>
  <div style="min-height: 100vh;">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div
      v-loading="isLoading"
      class="container introduce-facility top-spacing column"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div>
            <CardFacility
              :location="info.location"
              :rating="info.rating"
              :reviews_count="info.reviews_count"
              :holes_amount="info.holes_amount"
              :description="info.description"
              :image="images[0]"
              :id="info?.id"
              :title="info.name"
              :info="info"
            />
            <div style="height: 10px ;background:#E3E3E3"></div>
          </div>
          <div class="mt-20 mb-20 px-mobile">
            <FromCreate :info="info" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="des-facility px-mobile">
            <Info :info="info" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getBackGround } from "@/utils/wapAuth";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import CardFacility from "./components/CardFacility.vue";
import FromCreate from "../booking/FromBookByFacility.vue";
import ReviewFacility from "@/views/api/wapV2/review-facility";
import Info from "../facility/components/Info.vue";
export default {
  components: {
    MainNavBarWapV2,
    CardFacility,
    FromCreate,
    Info
  },
  name: "list-teetime",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  created() {
    console.log("this.$route.params______", this.$route.query);
    this.onGetDetailFacility();
  },
  data() {
    return {
      bg: getBackGround(),
      infoHeader: {
        title: this.$t("yardDetails"),
        isShowHomeIcon: true
      },
      title: "",
      query: this.$route.query,
      info: {},
      images: [],
      isLoading: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    onGetDetailFacility() {
      this.isLoading = true;
      const params = { id: this.query.facility_id };
      ReviewFacility.get_detail_facility(params)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0) {
            this.info = data;
            this.images = data.galleries
              .flatMap(item => item.images?.map(imgObj => imgObj.img))
              .slice(0, 5);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.top-spacing {
  padding-top: 100px;
}
.full-width {
  width: 100%;
}
.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-h3 {
    font-size: 16px;
  }
}
@media screen and (min-width: 0px) and (max-width: 480px) {
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .px-mobile {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
  .top-spacing1 {
    padding-top: 170px;
  }
  .title-h3 {
    font-size: 14px;
  }
  .introduce-facility {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .title-section {
    display: none;
  }
}
</style>
